<script setup lang = "ts">
const props = defineProps({
	imageClass: {type: String, required: false, default: ''},
	url: {type: String, required: true}
})

const $q = useQuasar()
const share = () => {
	$q.bottomSheet({
		message: 'Comparte en redes sociales',
		grid: true,
		actions: [
			{
				label: 'Facebook',
				classes: 'text-primary',
				icon: 'fa-brands fa-facebook text-[#1877f2]',
				id: 'facebook'
			},
			{
				label: 'X/Twitter',
				classes: 'text-primary',
				icon: 'fa-brands fa-x-twitter text-[#14171a]',
				id: 'twitter'
			},
			{
				label: 'Linkedin',
				classes: 'text-primary',
				icon: 'fa-brands fa-linkedin-in text-[#0a66c2]',
				id: 'linkedin'
			},
			{
				label: 'Email',
				classes: 'text-primary',
				icon: 'fa-solid fa-envelope text-primary',
				id: 'email'
			},
			{
				label: 'Telegram',
				classes: 'text-primary',
				icon: 'fa-brands fa-telegram text-[#0088cc]',
				id: 'telegram'
			},
			{
				label: 'Whatsapp',
				classes: 'text-primary',
				icon: 'fa-brands fa-whatsapp text-[#25d366]',
				id: 'whatsapp'
			},
		]
	}).onOk(action => {
		console.log(action,props.url)
		const share = useSocialShare({network: action.id, url: props.url})
		window.open(share.value.shareUrl, 'facebook-share-dialog', 'width=800,height=600');
	}).onCancel(() => {
		// console.log('Dismissed')
	}).onDismiss(() => {
		// console.log('I am triggered on both OK and Cancel')
	})
}
</script>

<template>
	<button class = "mr-2">
		<img :src = "`${useNuxtApp().$domain}/icons/share_primary.svg`"
				 @click = "share()"
				 :class = "imageClass"
				 alt = "Share"/>
	</button>

</template>

<style scoped>

</style>